import { c as _c } from "react/compiler-runtime";
import { cn } from '@/hooks/utils';
import React from 'react';
import { ImageComponent } from '@/components/ui/ImageComponent';
interface TestimonialBoxProps extends React.HTMLAttributes<HTMLDivElement> {
  quote: string;
  author: string;
  role: string;
  company: string;
  image?: string;
  logo?: string;
  imageClassName?: string;
  imageWrapperClassName?: string;
  imageWrapperOuterClassName?: string;
  authorClassName?: string;
  roleClassName?: string;
  className?: string;
  testimonialClassName?: string;
  logoClassName?: string;
}
export function TestimonialBox(t0) {
  const $ = _c(54);
  let author;
  let authorClassName;
  let className;
  let company;
  let image;
  let imageClassName;
  let imageWrapperClassName;
  let logo;
  let logoClassName;
  let quote;
  let rest;
  let role;
  let roleClassName;
  let testimonialClassName;
  if ($[0] !== t0) {
    const {
      quote: t1,
      author: t2,
      role: t3,
      company: t4,
      image: t5,
      logo: t6,
      imageClassName: t7,
      imageWrapperClassName: t8,
      imageWrapperOuterClassName,
      authorClassName: t9,
      roleClassName: t10,
      className: t11,
      testimonialClassName: t12,
      logoClassName: t13,
      ...t14
    } = t0;
    quote = t1;
    author = t2;
    role = t3;
    company = t4;
    image = t5;
    logo = t6;
    imageClassName = t7;
    imageWrapperClassName = t8;
    authorClassName = t9;
    roleClassName = t10;
    className = t11;
    testimonialClassName = t12;
    logoClassName = t13;
    rest = t14;
    $[0] = t0;
    $[1] = author;
    $[2] = authorClassName;
    $[3] = className;
    $[4] = company;
    $[5] = image;
    $[6] = imageClassName;
    $[7] = imageWrapperClassName;
    $[8] = logo;
    $[9] = logoClassName;
    $[10] = quote;
    $[11] = rest;
    $[12] = role;
    $[13] = roleClassName;
    $[14] = testimonialClassName;
  } else {
    author = $[1];
    authorClassName = $[2];
    className = $[3];
    company = $[4];
    image = $[5];
    imageClassName = $[6];
    imageWrapperClassName = $[7];
    logo = $[8];
    logoClassName = $[9];
    quote = $[10];
    rest = $[11];
    role = $[12];
    roleClassName = $[13];
    testimonialClassName = $[14];
  }
  let t1;
  if ($[15] !== className) {
    t1 = cn("flex h-full w-full max-w-[512px] gap-5 flex-col justify-between rounded-[24px] sm:rounded-[32px] bg-white p-5 shadow-[0_0_54px_0_rgba(0,0,0,0.02)] sm:p-8 sm:gap-[65px]", className);
    $[15] = className;
    $[16] = t1;
  } else {
    t1 = $[16];
  }
  let t2;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="mb-[2px] font-bricolage text-[24px] sm:text-[40px] tracking-[-0.8px] font-bold leading-none text-[#0B0623]">“</div>;
    $[17] = t2;
  } else {
    t2 = $[17];
  }
  let t3;
  if ($[18] !== testimonialClassName) {
    t3 = cn("font-sans text-[14px] sm:text-2xl leading-relaxed text-[#302B44]", testimonialClassName);
    $[18] = testimonialClassName;
    $[19] = t3;
  } else {
    t3 = $[19];
  }
  let t4;
  if ($[20] !== quote || $[21] !== t3) {
    t4 = <div>{t2}<blockquote className={t3}>{quote}</blockquote></div>;
    $[20] = quote;
    $[21] = t3;
    $[22] = t4;
  } else {
    t4 = $[22];
  }
  let t5;
  if ($[23] !== author || $[24] !== image || $[25] !== imageClassName || $[26] !== imageWrapperClassName) {
    t5 = image && <ImageComponent src={image} alt={author} fill={true} className={cn("z-1 object-contain overflow-auto", imageClassName)} containerClassName={cn("relative max-w-[120px] h-[160px]", imageWrapperClassName)} />;
    $[23] = author;
    $[24] = image;
    $[25] = imageClassName;
    $[26] = imageWrapperClassName;
    $[27] = t5;
  } else {
    t5 = $[27];
  }
  let t6;
  if ($[28] !== authorClassName) {
    t6 = cn("font-bricolage text-[13px] sm:text-[16px] font-bold leading-tight text-[#0B0623]", authorClassName);
    $[28] = authorClassName;
    $[29] = t6;
  } else {
    t6 = $[29];
  }
  let t7;
  if ($[30] !== author || $[31] !== t6) {
    t7 = <div className={t6}>{author}</div>;
    $[30] = author;
    $[31] = t6;
    $[32] = t7;
  } else {
    t7 = $[32];
  }
  let t8;
  if ($[33] !== roleClassName) {
    t8 = cn("mt-0.5 font-sans text-[11px] sm:text-[16px] text-[#302B44]", roleClassName);
    $[33] = roleClassName;
    $[34] = t8;
  } else {
    t8 = $[34];
  }
  let t9;
  if ($[35] !== role || $[36] !== t8) {
    t9 = <div className={t8}>{role}</div>;
    $[35] = role;
    $[36] = t8;
    $[37] = t9;
  } else {
    t9 = $[37];
  }
  let t10;
  if ($[38] !== company || $[39] !== logo || $[40] !== logoClassName) {
    t10 = logo && <ImageComponent src={logo} alt={company} fill={true} className="object-contain object-left" containerClassName={cn("mt-2 relative h-9", logoClassName)} />;
    $[38] = company;
    $[39] = logo;
    $[40] = logoClassName;
    $[41] = t10;
  } else {
    t10 = $[41];
  }
  let t11;
  if ($[42] !== t10 || $[43] !== t7 || $[44] !== t9) {
    t11 = <div>{t7}{t9}{t10}</div>;
    $[42] = t10;
    $[43] = t7;
    $[44] = t9;
    $[45] = t11;
  } else {
    t11 = $[45];
  }
  let t12;
  if ($[46] !== t11 || $[47] !== t5) {
    t12 = <div className="flex items-center gap-4">{t5}{t11}</div>;
    $[46] = t11;
    $[47] = t5;
    $[48] = t12;
  } else {
    t12 = $[48];
  }
  let t13;
  if ($[49] !== rest || $[50] !== t1 || $[51] !== t12 || $[52] !== t4) {
    t13 = <div className={t1} {...rest}>{t4}{t12}</div>;
    $[49] = rest;
    $[50] = t1;
    $[51] = t12;
    $[52] = t4;
    $[53] = t13;
  } else {
    t13 = $[53];
  }
  return t13;
}